<template>
  <modal back="edit-text" :title="$t('customization.changeEffect')">
    <div>
      <base-row
        v-for="effect of fontEffectList"
        :key="effect.id"
        class="h-12 relative flex justify-center py-2 items-center"
      >
        <a
          class="block float-none bg-no-repeat bg-contain bg-center h-full w-5/6 hover:cursor-pointer"
          :class="$style['effectimage']"
          :style="fontEffectImage(effect.image)"
          @click="closeModalAfter(() => selectEffect(effect))"
        />
        <div class="absolute pin-r">
          <base-icon
            v-if="effect.id === element.effect"
            size="xs"
            name="check-icon"
          />
        </div>
      </base-row>
    </div>
    <text-effect-config :active-element="activeElement"></text-effect-config>
  </modal>
</template>

<script>
import Modal from '../../components/Modal.vue';
import { TrackingMixin } from '../../mixins/gtm-tracking';
import TextEffectConfig from './TextEffectConfig.vue';
import { GETTER_FONT_EFFECT_LIST_BY_PRINTSTYLE } from '../../store/modules/font/getters';
import { GETTER_ACTIVE_PRINT_SIDE_PRINT_STYLE } from '../../store/getters';
import { CREATOR_BASE_URL } from '../../../utils/configure-environment';
import Redirect from '@/mixins/redirect';
import ActiveElement from '@/mixins/activeElement';

const assetsContext = require.context('../../assets/', false, /\.png$/);

export default {
  name: 'TextEffectChange',
  components: {
    Modal,
    TextEffectConfig
  },
  mixins: [TrackingMixin, ActiveElement, Redirect],
  computed: {
    fontEffectList() {
      return this.$store.getters[GETTER_FONT_EFFECT_LIST_BY_PRINTSTYLE](
        this.$store.getters[GETTER_ACTIVE_PRINT_SIDE_PRINT_STYLE]
      );
    }
  },
  methods: {
    fontEffectImage(effectImage) {
      return {
        '--bg-image': `url("${CREATOR_BASE_URL}/${assetsContext(
          `./text-effect-${effectImage}.png`
        )}")`
      };
    },
    selectEffect(effect) {
      this.updateElement({
        effect: effect.id,
        effectConfig: effect.config
      });

      this.trackEvent({
        action: 'ChangeTextEffect',
        label: effect.id
      });
    }
  }
};
</script>
<style lang="scss" module>
.effectimage {
  background-image: var(--bg-image);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
</style>
